import PuzzleService from '_services/rest/modules/puzzle';
import { handleResourceLoadError } from '_utils';

export default {
  state: {
    puzzleLoop: null,
    hasChanges: false,
  },
  mutations: {
    setPuzzleLoop(state, puzzleLoop) {
      state.puzzleLoop = puzzleLoop;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setPuzzleLoop({ commit }, model) {
      commit('setPuzzleLoop', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getPuzzleLoop({ commit, dispatch }, id) {
      return PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setPuzzleLoop', response);
          commit('setHasChanges', false);
        })
        .catch(error => {
          handleResourceLoadError(dispatch, error, 'admin-puzzle-loop-list');
        });
    },
  },
};
